export default "__VITE_PUBLIC_ASSET__4a6122fe__"